import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import { For, Show } from "solid-js";
import { relativeAge } from "../../ui/format";
import { EmptyState } from "./primitives";

// Activity tab: the version revision log as a compact timeline.
export function ActivityCards(props: { version: TovVersionResponse }) {
  const events = () => props.version.revisionEvents;
  return (
    <section class="tov-group">
      <h2 class="tov-group-title">Revision log</h2>
      <Show
        when={events().length > 0}
        fallback={<EmptyState label="activity" />}
      >
        <ul class="tov-timeline">
          <For each={events()}>
            {(event) => (
              <li class="tov-timeline-row">
                <span class="tov-chip">{event.actorType}</span>
                <div class="tov-timeline-body">
                  <span class="tov-timeline-summary">{event.summary}</span>
                  <span class="tov-sub">
                    {event.eventType} · {event.targetTable} ·{" "}
                    {relativeAge(new Date(event.createdAt))}
                  </span>
                </div>
              </li>
            )}
          </For>
        </ul>
      </Show>
    </section>
  );
}
